module.exports = __webpack_public_path__ + "media/event-access/conference@1x-066f5a7c.png";